import { render } from "./set_power.vue?vue&type=template&id=6b356baa&scoped=true"
import script from "./set_power.vue?vue&type=script&lang=js"
export * from "./set_power.vue?vue&type=script&lang=js"

import "./set_power.vue?vue&type=style&index=0&id=6b356baa&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\deyi\\baobei_web2\\web2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b356baa"]])

export default __exports__